export default __webpack_public_path__ + "static/media/TVSProductoDelMesFamilia.66093eb8.webp";